module.exports = __webpack_public_path__ + "static/media/appointment_p3_1.7691bd22.png";